import { useQuery } from "@tanstack/react-query";
import { adaptCarouselBanners } from "src/features/vendorSponsorship/adapters/adaptCarouselBanners";
import cmsClient from "src/services/cmsClient";

const fetchActiveBanners = async () => {
	const response = await cmsClient.get<IBanner[]>(
		"/homepage/admin/fullscreentakeover/",
		{
			params: {
				published: true,
			},
		}
	);

	return response.data;
};

interface Options {
	onSuccess?: (banners: Banner[]) => void;
}

const useActiveFullScreenTakeovers = (options: Options = {}) => {
	const query = useQuery(
		["full-screen-takeover-active-banners"],
		fetchActiveBanners,
		{
			select: adaptCarouselBanners,
			...options,
		}
	);

	return query;
};

export default useActiveFullScreenTakeovers;
